// Ιστορικό του editor: Αναίρεση/Επανάληψη, «N αλλαγές χωρίς αποθήκευση».
// Συνεχόμενες αλλαγές στο ίδιο πεδίο (π.χ. πληκτρολόγηση αριθμού) γίνονται ΜΙΑ αλλαγή.
// Ίδιο με τη Sala (xentrix_table src/screens/floor/history.ts).

import { useCallback, useReducer } from 'react';
import type { FloorDoc } from '../../../utils/salaFloor/floor';

interface State { doc: FloorDoc; past: FloorDoc[]; future: FloorDoc[]; lastKey: string | null }
type Action =
  | { type: 'set'; doc: FloorDoc; key?: string | null }
  | { type: 'undo' }
  | { type: 'redo' }
  | { type: 'reset'; doc: FloorDoc; dirty?: boolean };

const LIMIT = 100;

export function reduce(s: State, a: Action): State {
  switch (a.type) {
    case 'set': {
      if (a.doc === s.doc) return s;
      const same = !!a.key && a.key === s.lastKey;
      return { doc: a.doc, past: same ? s.past : [...s.past, s.doc].slice(-LIMIT), future: [], lastKey: a.key || null };
    }
    case 'undo':
      if (!s.past.length) return s;
      return { doc: s.past[s.past.length - 1], past: s.past.slice(0, -1), future: [s.doc, ...s.future], lastKey: null };
    case 'redo':
      if (!s.future.length) return s;
      return { doc: s.future[0], past: [...s.past, s.doc], future: s.future.slice(1), lastKey: null };
    case 'reset':
      // dirty: ο οδηγός πρώτου στησίματος φτιάχνει κάτοψη που δεν έχει αποθηκευτεί ακόμα.
      return { doc: a.doc, past: a.dirty ? [{ rooms: [], fixtures: [], tables: [], combos: [] }] : [], future: [], lastKey: null };
    default:
      return s;
  }
}

export function useFloorHistory(initial: FloorDoc) {
  const [s, dispatch] = useReducer(reduce, { doc: initial, past: [], future: [], lastKey: null });
  return {
    doc: s.doc,
    changes: s.past.length,
    canUndo: s.past.length > 0,
    canRedo: s.future.length > 0,
    set: useCallback((doc: FloorDoc, key?: string | null) => dispatch({ type: 'set', doc, key }), []),
    undo: useCallback(() => dispatch({ type: 'undo' }), []),
    redo: useCallback(() => dispatch({ type: 'redo' }), []),
    reset: useCallback((doc: FloorDoc, dirty?: boolean) => dispatch({ type: 'reset', doc, dirty }), []),
  };
}
